export enum AnalyticsEventPageId {
  Timeline = "Timeline",
  Copilot = "Copilot",
  Recordings = "Recordings",
  Liveview = "LiveView",
  Compare = "Compare",
  BimCompare = "BimCompare",
  Sharing = "Sharing",
  Timelapse = "Timelapse",
  Project = "Project",
  AllProjects = "AllProjects",
  Tutorials = "Tutorials",
  ProjectMapView = "ProjectMapView",
  AccountMapView = "AccountMapView",
  Automations = "Automations",
  ProgressPhotosUnsubscribe = "ProgressPhotosUnsubscribe",
  VideoWall = "VideoWall",
  ProjectSettings = "ProjectSettings",
  ProjectSettingsCameraSettings = "ProjectSettings-CameraSettings",
  ProjectSettingsMembers = "ProjectSettings-Members",
  ProjectSettingsOverview = "ProjectSettings-Overview",
  Settings = "Settings",
  SettingsAccount = "Settings-Account",
  SettingsConnectors = "Settings-Connectors",
  MediaHub = "MediaHub",
  MediaOveriew = "MediaOveriew",
  GateReport = "GateReport",
  Bim = "Bim",
  Drone = "Drone",
  ThreeSixty = "360",
  Planner = "Planner",
  Widgets = "Widgets",
  Company = "Company",
  EmbeddedLive = "EmbeddedLive",
  EmbeddedRecordings = "EmbeddedRecordings",
  EmbeddedBimCompare = "EmbeddedBimCompare",
  GateReportInfo = "GateReportInfo",
  BimInfo = "BimInfo",
  DroneInfo = "DroneInfo",
  ThreeSixtyInfo = "360Info",
  BimCompareInfo = "BimCompareInfo",
  WeatherReport = "WeatherReport",
}

export enum AnalyticsEvent {
  // Global events
  PageView = "PageView",
  OpenCompanyPage = "OpenCompanyPage",
  OpenSettings = "OpenSettings",
  ToggleHelpDialog = "ToggleHelpDialog",

  // Layout events
  LayoutToggleRightSidebar = "Layout-ToggleRightSidebar",
  LayoutResizeRightSidebar = "Layout-ResizeRightSidebar",
  LayoutThemeMode = "Layout-ThemeMode",

  // Features toggle events
  Xray = "Xray-Toggle",
  Weather = "Weather-Toggle",
  MarkUpTool = "MarkUpTool-Toggle",
  Comment = "Comment-Toggle",
  Compare = "Compare-Toggle",
  Copilot = "Copilot-Toggle",
  DownloadMediaOpen = "DownloadMedia-Open",

  // App settings events
  SettingsAccountUpdatePassword = "UpdatePassword",
  SettingsAccountUpdatePersonalInformation = "UpdatePersonalInformation",
  SettingsAccountRevokeSession = "RevokeSession",
  SettingsAccountCancelRevokeSession = "CancelRevokeSession",
  SettingsAccountClickRowsPerPage = "ClickRowsPerPage",
  SettingsAccountOpenDeleteAccountDialog = "DeleteAccount",
  SettingsConnectorsConnectToProcore = "ConnectToProcore",
  SettingsConnectorsConnectToAconex = "ConnectToAconex",
  SettingsConnectorsConnectToAutodesk = "ConnectToAutodesk",
  SettingsConnectorsConnectToVoyageControl = "ConnectToVoyageControl",
  SettingsConnectorsContactUsButtonClick = "ClickContactUs",
  SettingsConnectorsRemoveAconexConnection = "RemoveAconex",
  SettingsConnectorsRemoveAutodeskConnection = "RemoveAutodesk",
  SettingsConnectorsRemoveProcoreConnection = "RemoveProcore",
  SettingsConnectorsRemoveVoyageControlConnection = "RemoveVoyageControl",
  SettingsConnectorsToggleConnectorPromptDialog = "ToggleConnectorPromptDialog",
  SettingsConnectorsToggleVoyageControlDialog = "ToggleVoyageControlDialog",

  // Widgets events
  WidgetsAddWidgetClick = "AddWidget",
  WidgetsCancelClick = "Cancel",
  WidgetsEditHeight = "EditHeight",
  WidgetsEditHeightResolutionType = "EditHeightResolutionType",
  WidgetsEditWidth = "EditWidth",
  WidgetsEditWidthResolutionType = "EditWidthResolutionType",
  WidgetsLayout = "ClickLayout",
  WidgetsSaveClick = "Save",
  WidgetsSelectCamera = "SelectCamera",
  WidgetsSelectTypeBIMCompare = "SelectTypeBIMCompare",
  WidgetsSelectTypeLiveView = "SelectTypeLiveView",
  WidgetsSelectTypeRecordings = "SelectTypeRecordings",
  WidgetsSelectTypeVideoWall = "SelectTypeVideoWall",
  WidgetsSettingRefreshRate = "EditRefreshRate",
  WidgetsSettingRestrictRecentImagesInput = "EditRestrictRecentImagesInput",
  WidgetsSettingToggleBIMCompareDarkMode = "ToggleBIMDarkMode",
  WidgetsSettingToggleBIMCompareTimeLine = "ToggleBIMTimeline",
  WidgetsSettingToggleBIMCompareCalendar = "ToggleBIMCalendar",
  WidgetsSettingToggleDownload = "ToggleDownload",
  WidgetsSettingToggleFullScreen = "ToggleFullScreen",
  WidgetsSettingTogglePlayPause = "TogglePlayPause",
  WidgetsSettingToggleRecordingsCalendar = "ToggleRecordingsCalendar",
  WidgetsSettingToggleRecordingsDarkMode = "ToggleRecordingsDarkMode",
  WidgetsSettingToggleRestrictRecentImages = "ToggleRestrictRecentImages",
  WidgetsSettingToggleZoom = "ToggleZoom",
  WidgetsTogglePublicWidget = "TogglePublicWidget",

  // Player events
  PlayerSelectCamera = "Player-SelectCamera",
  PlayerDownload = "Player-Download",
  PlayerToggleFullscreen = "Player-ToggleFullscreen",
  PlayerEnableLive = "Player-EnableLive",
  PlayerTogglePlayback = "Player-TogglePlayback",
  PlayerSelectSpeed = "Player-SelectSpeed",
  PlayerSelectQuality = "Player-SelectQuality",
  PlayerJumptoNextTicks = "Player-JumptoNextTicks",
  PlayerJumptoPreviousTicks = "Player-JumptoPreviousTicks",
  PlayerSwitchMode = "Player-SwitchMode",
  PlayerZoomIn = "Player-ZoomIn",
  PlayerZoomOut = "Player-ZoomOut",

  // PTZ camera events
  PTZAddPresetClick = "PTZ-AddPresetClick",
  PTZCreatePreset = "PTZ-CreatePreset",
  PTZUpdatePreset = "PTZ-UpdatePreset",
  PTZDeletePreset = "PTZ-DeletePreset",
  PTZMoveDown = "PTZ-MoveDown",
  PTZMoveLeft = "PTZ-MoveLeft",
  PTZMoveRight = "PTZ-MoveRight",
  PTZMoveUp = "PTZ-MoveUp",
  PTZPresetSelect = "PTZ-PresetSelect",
  PTZResetPosition = "PTZ-ResetPosition",
  PTZToggleCreatePresetForm = "PTZ-ToggleCreatePresetForm",
  PTZToggleDeletePresetDialog = "PTZ-ToggleDeletePresetDialog",
  PTZToggleEditPresetForm = "PTZ-ToggleEditPresetForm",
  PTZTogglePresetsMenu = "PTZ-TogglePresetsMenu",
  PTZZoomIn = "PTZ-ZoomIn",
  PTZZoomOut = "PTZ-ZoomOut",

  // Timeline actions
  TimelineClickEvent = "Timeline-ClickEvent",
  TimelineCompareMoveBeforeMarker = "Compare-MoveBeforeMarker",
  TimelineCompareMoveAfterMarker = "Compare-MoveAfterMarker",
  TimelineCompareSlide = "Compare-Slide",
  TimelineSelectMilestoneItem = "Timeline-SelectMilestoneItem",
  TimelineSelectTimestamp = "Timeline-SelectTimestamp",

  // Copilot
  CopilotSendMessage = "Copilot-SendMessage",
  CopilotClickTimestamp = "Copilot-ClickTimestamp",
  CopilotRegenerate = "Copilot-Regenerate",
  CopilotError = "Copilot-Error",
  CopilotNavigation = "Copilot-Navigation",
  CopilotToggle = "Copilot-Toggle",

  // Timeline groups visibility events
  GroupsVisibilityMobileCapture = "GroupsVisibility-MobileCapture",
  GroupsVisibilityAnpr = "GroupsVisibility-Anpr",
  GroupsVisibilityComments = "GroupsVisibility-Comments",
  GroupsVisibilityMediaHub = "GroupsVisibility-MediaHub",
  GroupsVisibilityBimMilestones = "GroupsVisibility-BimMilestines",
  GroupsVisibilityDroneFlights = "GroupsVisibility-DroneFlights",
  GroupsVisibility360Walks = "GroupsVisibility-360Walks",
  GroupsVisibilityExNvrVideoRecordings = "GroupsVisibility-ExNvrVideoRecordings",
  GroupsVisibilityLuminance = "GroupsVisibility-Luminance",

  // Comments events
  CommentsPlaceMarker = "Comments-PlaceMarker",
  CommentsSave = "Comments-Save",
  CommentsCancelSave = "Comments-CancelSave",
  CommentsRemove = "Comments-Remove",
  CommentsCancelRemove = "Comments-CancelRemove",
  CommentsArchive = "Comments-Archive",
  CommentsCancelArchive = "Comments-CancelArchive",
  CommentsSelect = "Comments-Select",

  // Xray events
  XrayMove = "Xray-Move",
  XrayMoveBeforeMarker = "Xray-MoveBeforeMarker",
  XrayMoveAfterMarker = "Xray-MoveAfterMarker",
  XrayToggleExportDialog = "Xray-ToggleExportDialog",
  XrayDownload = "Xray-Download",
  XraySaveToMediaHub = "Xray-SaveToMediaHub",
  XarySelectDate = "Xray-SelectDate",
  XarySelectLatestDate = "Xray-SelectLatestDate",
  XarySelectOldestDate = "Xray-SelectOldestDate",
  XraySendToConnector = "Xray-SendToConnector",

  // Weather events
  WeatherGoBackDate = "Weather-GoBackDate",
  WeatherGoForwardDate = "Weather-GoForwardDate",
  WeatherReportExportFile = "ExportFile",
  WeatherReportExportType = "ExportType",
  WeatherReportMediaHubUploadFile = "MediaHubUploadFile",
  WeatherReportSelectStartDate = "SelectStartDate",
  WeatherReportSelectEndDate = "SelectEndDate",
  WeatherReportViewChart = "ViewChart",
  WeatherSelectDate = "Weather-SelectDate",
  WeatherSelectLegend = "Weather-SelectLegend",
  WeatherSelectProvider = "Weather-SelectProvider",
  WeatherSelectTempScale = "Weather-SelectTempScale",

  // Compare events
  CompareSlide = "Slide",
  CompareSelectBeforeDate = "SelectBeforeDate",
  CompareSelectBeforeLatestDate = "SelectBeforeLatestDate",
  CompareSelectBeforeOldestDate = "SelectBeforeOldestDate",
  CompareSelectAfterDate = "SelectAfterDate",
  CompareSelectAfterOldestDate = "SelectAfterOldestDate",
  CompareSelectAfterLatestDate = "SelectAfterLatestDate",
  CompareToggleExportDialog = "ToggleExportDialog",
  CompareSaveToMediaHub = "SaveToMediaHub",
  CompareGoToMediaHub = "GoToMediaHub",
  CompareDownloadAs = "DownloadAs",
  CompareCopyDownloadFileUrl = "CopyDownloadFileUrl",

  // Bim Compare events
  BimCompareSlide = "BimCompare-Slide",
  BimCompareSelectCameraDate = "BimCompare-SelectCameraDate",
  BimCompareSelectCameraLatestDate = "BimCompare-SelectCameraLatestDate",
  BimCompareSelectCameraOldestDate = "BimCompare-SelectCameraOldestDate",
  BimCompareSelectBimDate = "BimCompare-SelectBimDate",
  BimCompareSelectBimOldestDate = "BimCompare-SelectBimOldestDate",
  BimCompareSelectBimLatestDate = "BimCompare-SelectBimLatestDate",
  BimCompareSelectModel = "BimCompare-SelectModel",
  BimCompareChangeTransparency = "BimCompare-ChangeTransparency",
  BimCompareSelectTimelineDate = "BimCompare-SelectTimelineDate",
  BimCompareToggleExportDialog = "BimCompare-ToggleExportDialog",
  BimCompareSaveToMediaHub = "BimCompare-SaveToMediaHub",
  BimCompareGoToMediaHub = "BimCompare-GoToMediaHub",
  BimCompareDownloadAs = "BimCompare-DownloadAs",
  BimCompareCopyDownloadFileUrl = "BimCompare-CopyDownloadFileUrl",

  // Mark-up tool events
  MarkUpToolClose = "MarkUpTool-Close",
  MarkUpToolCopyImage = "MarkUpTool-CopyImage",
  MarkUpToolOpen = "MarkUpTool-Open",
  MarkUpToolSelectTool = "MarkUpTool-SelectTool",
  MarkUpToolSelectBlur = "MarkUpTool-SelectBlur",
  MarkUpToolSelectCrop = "MarkUpTool-SelectCrop",
  MarkUpToolSelectLine = "MarkUpTool-SelectLine",
  MarkUpToolSelectBrush = "MarkUpTool-SelectBrush",
  MarkUpToolSelectRectangle = "MarkUpTool-SelectRectangle",
  MarkUpToolSelectCircle = "MarkUpTool-SelectCircle",
  MarkUpToolSelectArrow = "MarkUpTool-SelectArrow",
  MarkUpToolSelectText = "MarkUpTool-SelectText",
  MarkUpToolUndo = "MarkUpTool-Undo",
  MarkUpToolRedo = "MarkUpTool-Redo",
  MarkUpToolSelectColor = "MarkUpTool-SelectColor",
  MarkUpToolApplyCrop = "MarkUpTool-ApplyCrop",
  MarkUpToolCancelCrop = "MarkUpTool-CancelCrop",
  MarkUpToolCancelSend = "MarkUpTool-CancelSend",
  MarkUpToolOpenEditName = "MarkUpTool-OpenEditName",
  MarkUpToolCancelEditName = "MarkUpTool-CancelEditName",
  MarkUpToolSaveEditedName = "MarkUpTool-SaveEditedName",
  MarkUpToolSaveToMediaHub = "MarkUpTool-SaveToMediaHub",
  MarkUpToolDownloadAs = "MarkUpTool-DownloadAs",
  MarkUpToolSendToConnector = "MarkUpTool-SendToConnector",

  // Ai Tools events
  AiToolToggleBrainToolsMenu = "AITool-ToggleBrainToolsMenu",
  AiToolSelectObjectDetection = "AITool-SelectObjectDetection",
  AiToolSelectAskChatGpt = "AITool-SelectAskChatGpt",
  AiToolSelectSegmentation = "AITool-SelectSegmentation",
  AiToolSelectDepthAnalysis = "AITool-SelectDepthAnalysis",
  AiToolUpdateTransparency = "AITool-UpdateTransparency",

  // Recordings events
  RecordingsCancelExportDialog = "CancelExportDialog",
  RecordingsClickSupportLink = "ClickSupportLink",
  RecordingsCreateClip = "CreateClip",
  RecordingsToggleExportDialog = "ToggleExportDialog",
  RecordingToggleGateReportEvents = "ToggleGateReportEvents",
  RecordingsSelectDate = "SelectDate",
  RecordingsSelectDateClickMonthYear = "SelectDate-ClickMonthYear",
  RecordingsSelectLatestDate = "SelectLatestDate",
  RecordingsSelectOldestDate = "SelectOldestDate",

  // Sharing events
  SharingToggleAddUserDialog = "ToggleAddUserDialog",
  SharingToggleEditVisibilityOptionsDialog = "ToggleEditVisibilityOptionsDialog",
  SharingAddUser = "AddUser",
  SharingToggleDeleteUserDialog = "ToggleDeleteUserDialog",
  SharingDeleteUser = "DeleteUser",
  SharingSaveVisibilityOptions = "SaveVisibilityOptions",
  SharingCopyLink = "CopyLink",
  SharingResendInvite = "ResendInvite",
  SharingTransferOwnership = "TransferOwnership",
  SharingSortBy = "SortBy",
  SharingChangeAccessRight = "ChangeAccessRight",

  // ThreeSixty events
  ThreeSixtyChangeDate = "ChangeDate",
  ThreeSixtyChangeFloor = "ChangeFloor",
  ThreeSixtyCloseCompare = "CloseCompare",
  ThreeSixtyCloseForgeBIM = "CloseForgeBIM",
  ThreeSixtyDeleteTag = "DeleteTag",
  ThreeSixtyDisableMeasuringTool = "DisableMeasuringTool",
  ThreeSixtyDisableTagTool = "DisableTagTool",
  ThreeSixtyEnableMeasuringTool = "EnableMeasuringTool",
  ThreeSixtyEnableTagTool = "EnableTagTool",
  ThreeSixtyLockCompare = "LockCompare",
  ThreeSixtyLockForgeBIM = "LockForgeBIM",
  ThreeSixtyMarkerThumbnailClicked = "MarkerThumbnailClicked",
  ThreeSixtyMiniMapMarkerClicked = "MiniMapMarkerClicked",
  ThreeSixtyOpen = "Open",
  ThreeSixtyOpenCompare = "OpenCompare",
  ThreeSixtyOpenForgeBIM = "OpenForgeBIM",
  ThreeSixtyOpenMarkersThumbnailsList = "OpenMarkersThumbnailsList",
  ThreeSixtyOpenTagsList = "OpenTagsList",
  ThreeSixtySaveTag = "SaveTag",
  ThreeSixtyShareView = "ShareView",
  ThreeSixtyTagClicked = "TagClicked",
  ThreeSixtyToggleMarkersVisibility = "ToggleMarkersVisibility",
  ThreeSixtyToggleMinimapVisibility = "ToggleMinimapVisibility",
  ThreeSixtyToggleMiniModel = "ToggleMiniModel",
  ThreeSixtyToggleTagsVisibility = "ToggleTagsVisibility",
  ThreeSixtyTourPause = "Tour-Pause",
  ThreeSixtyTourPlay = "Tour-Play",
  ThreeSixtyTourSetSpeedXHalve = "Tour-SetSpeedX0.5",
  ThreeSixtyTourSetSpeedX1 = "Tour-SetSpeedX1",
  ThreeSixtyTourSetSpeedX2 = "Tour-SetSpeedX2",
  ThreeSixtyTourSetSpeedX4 = "Tour-SetSpeedX4",
  ThreeSixtyTourToggleLoop = "Tour-ToggleLoop",
  ThreeSixtyUnlockCompare = "UnlockCompare",
  ThreeSixtyUnlockForgeBIM = "UnlockForgeBIM",

  // Drone events
  DroneAreaToolClick = "AreaTool-Click",
  DroneChangeDate = "ChangeDate",
  DroneChooseTagType = "ChooseTagType",
  DroneClickCameraLiveView = "ClickCameraLiveView",
  DroneClickCameraMarker = "ClickCameraMarker",
  DroneCompareToolClick = "CompareTool-Click",
  DroneCompareToolSaveToMediaHub = "CompareToolSaveToMediaHub",
  DroneCompareToolSliderMove = "CompareTool-SliderMove",
  DroneCompareToolToggleExportDialog = "CompareToolToggleExportDialog",
  DroneCopyLocationToClipboard = "CopyLocationToClipboard",
  DroneEnable2DImagery = "Enable2DImagery",
  DroneGenerateUploadFlight = "GenerateUploadFlight",
  DroneInspectionToolClick = "InspectionTool-Click",
  DroneMeasuringToolClick = "MeasuringTool-Click",
  DroneOpenHelpPanel = "OpenHelpPanel",
  DroneOpenImageViewer = "OpenImageViewer",
  DroneResetView = "ResetView",
  DroneSaveTag = "SaveTag",
  DroneSettingsToggle360PathsVisibility = "Settings-Toggle360PathsVisibility",
  DroneSettingsToggleCameraMarkersVisibility = "Settings-ToggleCameraMarkersVisibility",
  DroneSettingsToggleSurroundingBuildingsTool = "Settings-ToggleSurroundingBuildingsTool",
  DroneSettingsToggleTagsVisibility = "Settings-ToggleTagsVisibility",
  DroneShareLink = "ShareLink",
  DroneTagsToolClick = "TagsTool-Click",
  DroneToggleBimCompareTool = "ToggleBimCompareTool",
  DroneToggleFullScreen = "ToggleFullScreen",
  DroneToggleMapStyle = "ToggleMapStyle",
  DroneToggleQualityMode = "ChooseQuality",
  DroneToggleSideMenu = "ToggleSideMenu",
  DroneToggleImageryPlan = "ToggleImageryPlan",
  DroneToggleSceneMode = "ToggleSceneMode",
  DroneUploadFlight = "UploadFlight",
  DroneViewLocationInGoogleMaps = "ViewLocationInGoogleMaps",
  DroneVolumeToolClick = "VolumeTool-Click",
  DroneZoomIn = "ZoomIn",
  DroneZoomOut = "ZoomOut",

  // Planner events
  PlannerAddCameraClick = "AddCameraClick",
  PlannerAddSitePlanDrawingClick = "AddSitePlanDrawingClick",
  PlannerAddSitePlanClick = "AddSitePlanClick",
  PlannerAttachSitePlanDrawing = "AttachSitePlanDrawing",
  PlannerCameraMarkerEditFOVAngle = "CameraMarker-EditFOVAngle",
  PlannerCameraMarkerEditHeading = "CameraMarker-EditHeading",
  PlannerCameraMarkerEditName = "CameraMarker-EditName",
  PlannerCameraMarkerEditRadius = "CameraMarker-EditRadius",
  PlannerCameraMarkerSelectColor = "CameraMarker-SelectColor",
  PlannerCameraMarkerToggleVisibility = "CameraMarker-ToggleVisibility",
  PlannerCameraMarkerToggleDeleteDialog = "CameraMarker-ToggleDeleteDialog",
  PlannerCancelUploadSitePlanDrawing = "CancelUploadSitePlanDrawing",
  PlannerChangeLocation = "ChangeLocation",
  PlannerOpen = "Open",
  PlannerResetView = "ResetView",
  PlannerSitePlansList = "SitePlansList",
  PlannerToggleCamerasLabel = "ToggleCamerasLabel",
  PlannerToggleFullscreen = "ToggleFullscreen",
  PlannerToggleMapStyle = "ToggleMapStyle",
  PlannerToggleSaveSessionDialog = "ToggleSaveSessionDialog",
  PlannerUploadSitePlanDrawing = "UploadSitePlanDrawing",
  PlannerZoomIn = "ZoomIn",
  PlannerZoomOut = "ZoomOut",

  // Markers events
  MarkerClicked = "MarkerClicked",

  // Timelapse Creator events
  TimelapseToggleHelpDialog = "ToggleHelpDialog",
  TimelapseSelectCustomPeriod = "SelectCustomPeriod",
  TimelapseToggleCustomScheduleDialog = "ToggleCustomScheduleDialog",
  TimelapseSaveCustomSchedule = "SaveCustomSchedule",
  TimelapseToggleExportDialog = "ToggleExportDialog",
  TimelapseExportSelectStep = "SelectStep",
  TimelapseSelectOption = "SelectOption",
  TimelapseSelectSchedule = "SelectSchedule",
  TimelapseSaveToMediaHub = "SaveToMediaHub",
  TimelapseGoToMediaHub = "GoToMediaHub",
  TimelapseToggleUploadLogoDialog = "ToggleUploadLogoDialog",
  TimelapseUploadLogo = "UploadLogo",

  // Progress Photos events
  ProgressPhotoCancelPause = "ProgressPhoto-CancelPause",
  ProgressPhotoCancelResume = "ProgressPhoto-CancelResume",
  ProgressPhotoCancelDelete = "ProgressPhoto-CancelDelete",
  ProgressPhotoCreate = "ProgressPhoto-Create",
  ProgressPhotoDelete = "ProgressPhoto-Delete",
  ProgressPhotoEdit = "ProgressPhoto-Edit",
  ProgressPhotoEditCamerasFilter = "ProgressPhoto-EditCamerasFilter",
  ProgressPhotoEditDaysFilter = "ProgressPhoto-EditDaysFilter",
  ProgressPhotoEditProjectsFilter = "ProgressPhoto-EditProjectsFilter",
  ProgressPhotoEditSearchFilter = "ProgressPhoto-EditSearchFilter",
  ProgressPhotoEditStatusFilter = "ProgressPhoto-EditStatusFilter",
  ProgressPhotoEditUsersFilter = "ProgressPhoto-EditUsersFilter",
  ProgressPhotoFiltersClicked = "ProgressPhoto-FiltersClicked",
  ProgressPhotoPause = "ProgressPhoto-Pause",
  ProgressPhotoResume = "ProgressPhoto-Resume",
  ProgressPhotoResumeDelete = "ProgressPhoto-ResumeDelete",
  ProgressPhotoSelectCameras = "ProgressPhoto-SelectCameras",
  ProgressPhotoSelectDays = "ProgressPhoto-SelectDays",
  ProgressPhotoSelectMember = "ProgressPhoto-SelectMember",
  ProgressPhotoSelectProvider = "ProgressPhoto-SelectProvider",
  ProgressPhotoSelectTime = "ProgressPhoto-SelectTime",
  ProgressPhotoSelectTimezone = "ProgressPhoto-SelectTimezone",
  ProgressPhotoToggleCreateDialog = "ProgressPhoto-ToggleCreateDialog",
  ProgressPhotoToggleEditDialog = "ProgressPhoto-ToggleEditDialog",
  ProgressPhotoUnsubscribeUser = "ProgressPhoto-UnsubscribeUser",

  // Map View events
  MapViewChooseSatellite = "MapView-ChooseSatellite",
  MapViewChooseTerrain = "MapView-ChooseMap",
  MapViewClickCameraLink = "MapView-ClickCameraLink",
  MapViewToggleCameraMapInfoTooltip = "MapView-ToggleCameraMapInfoTooltip",

  // Video Wall events
  VideoWallToggleFullscreen = "VideoWall-ToggleFullscreen",
  VideoWallToggleCameraFullscreen = "VideoWall-ToggleCameraFullscreen",
  VideoWallToggleConfigDialog = "VideoWall-ToggleConfigDialog",
  VideoWallToggleCameraVisibility = "VideoWall-ToggleCameraVisibility",
  VideoWallPositionCameraOnWall = "VideoWall-PositionCameraOnWall",
  VideoWallSaveConfig = "VideoWall-SaveConfig",

  // Project Settings
  ProjectSettingsCameraSettingsCancelEditCameraName = "CancelEditCameraName",
  ProjectSettingsCameraSettingsEditCameraName = "EditCameraName",
  ProjectSettingsCameraSettingsEditCameraVisibility = "EditCameraVisibility",
  ProjectSettingsCameraSettingsSaveCameraName = "SaveCameraName",
  ProjectSettingsMembersApplyCamerasFilter = "ApplyCamerasFilter",
  ProjectSettingsMembersApplySearchFilter = "ApplySearchFilter",
  ProjectSettingsMembersAddMember = "AddMember",
  ProjectSettingsMembersDeleteCameraAccess = "DeleteCameraAccess",
  ProjectSettingsMembersEditCameraAccess = "EditCameraAccess",
  ProjectSettingsMembersFiltersClick = "FiltersClick",
  ProjectSettingsMembersShareCamera = "ShareCamera",
  ProjectSettingsMembersToggleAddDialog = "ToggleAddDialog",
  ProjectSettingsOverviewOpenInMapView = "OpenInMapView",
  ProjectSettingsOverviewCloseUpdateThumbnailDialog = "CloseUpdateThumbnailDialog",
  ProjectSettingsOverviewOpenUpdateThumbnailDialog = "UpdateThumbnailClicked",
  ProjectSettingsOverviewUploadNewThumbnail = "UploadNewThumbnail",
  ProjectSettingsOverviewUpdateThumbnail = "UpdateThumbnail",

  // Media Hub events
  MediaHubSelectFilter = "SelectFilter",
  MediaHubApplyFilters = "ApplyFilters",
  MediaHubToggleAddMediaUrlDialog = "ToggleAddMediaUrlDialog",
  MediaHubToggleUploadFileDialog = "ToggleUploadFileDialog",
  MediaHubToggleUploadLocalClipDialog = "ToggleUploadLocalClipDialog",
  MediaHubSaveMediaUrl = "SaveMediaUrl",
  MediaHubUploadFile = "UploadFile",
  MediaHubSelectPage = "SelectPage",
  MediaHubGoToNextPage = "GoToNextPage",
  MediaHubGoToPreviousPage = "GoToPreviousPage",

  // Media Hub Item events
  MediaDelete = "Media-Delete",
  MediaToggleTitleEditing = "Media-ToggleTitleEditing",
  MediaSaveTitle = "Media-SaveTitle",
  MediaDownloadAs = "Media-DownloadAs",
  MediaTogglePublicVisibility = "Media-TogglePublicVisibility",
  MediaShareToPlatform = "Media-ShareToPlatform",
  MediaCopyMediaLink = "Media-CopyMediaLink",
  MediaGoToMediaHub = "Media-GoBackToMediaHub",

  // Gate report
  GateReportCalendarTreeDateClick = "CalendarTree-DateClick",
  GateReportExportPdf = "ExportPdf",
  GateReportExportCsv = "ExportCsv",
  GateReportFilterEntryExit = "FilterEntryExit",
  GateReportFilterCameras = "FilterCameras",
  GateReportFilterPlateNumber = "FilterPlateNumber",
  GateReportFilterVehicleTypes = "FilterVehicleTypes",
  GateReportOpenVehicleTypeInfo = "OpenVehicleTypeInfo",
  GateReportTimelineDateClick = "Timeline-DateClick",
  GateReportToggleThumbnails = "ToggleThumbnails",

  // TODO: The events bellow are old events, should be updated!

  //Help Menu
  HelpMenuToggleMenuButton = "HelpMenu-ToggleMenuButton",
  HelpMenuOpenLiveChat = "HelpMenu-OpenLiveChat",
  HelpMenuClickTutorialsLink = "HelpMenu-ClickTutorialsLink",
  HelpMenuClickWhatsNewLink = "HelpMenu-ClickWhatsNewLink",
  HelpMenuClickUserManuaLink = "HelpMenu-ClickUserManuaLink",
  HelpMenuClickSupportTicketsLink = "HelpMenu-ClickSupportTicketsLink",
}
